import { ButtonHTMLAttributes, FC } from "react";

const xCharacter = <>&#x2715;</>;
const CancelButton: FC<ButtonHTMLAttributes<HTMLButtonElement>> = (props) => (
    <button {...props}>{xCharacter}</button>
);

export default CancelButton;
